var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    ref: "contentElement",
    class: _vm.model.className,
    style: { resize: _vm.model.question.resizeStyle },
    attrs: {
      readonly: _vm.model.isReadOnlyAttr,
      disabled: _vm.model.isDisabledAttr,
      id: _vm.model.id,
      maxlength: _vm.model.maxLength,
      cols: _vm.model.cols,
      rows: _vm.model.rows,
      placeholder: _vm.model.placeholder,
      "aria-required": _vm.model.ariaRequired,
      "aria-label": _vm.model.ariaLabel,
      "aria-labelledby": _vm.model.ariaLabelledBy,
      "aria-describedby": _vm.model.ariaDescribedBy,
      "aria-invalid": _vm.model.ariaInvalid,
      "aria-errormessage": _vm.model.ariaErrormessage,
    },
    domProps: { value: _vm.value },
    on: {
      focus: function (e) {
        _vm.model.onTextAreaFocus(e)
      },
      blur: function (e) {
        _vm.model.onTextAreaBlur(e)
      },
      change: function (e) {
        _vm.model.onTextAreaChange(e)
      },
      input: function (e) {
        _vm.model.onTextAreaInput(e)
      },
      keydown: function (e) {
        _vm.model.onTextAreaKeyDown(e)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }